import React from "react";
import { Button, ButtonProps } from "react-bootstrap";
import { useSelector } from "react-redux";
import { hover, HoverProps } from "reactcss";
import { useButtonStyles } from "checkout/ts/hooks/useButtonStyles";
import { StateShape } from "checkout/ts/redux/store";
import classnames from "classnames";

type OwnProps = ButtonProps & HoverProps<void>;

export const DialogButton = hover(({ className, hover, onClick, href, ...props }: OwnProps) => {
    const buttonStyle = useButtonStyles(hover);
    const {
        params: { preventStepNavigation },
    } = useSelector((state: StateShape) => state.application.params);

    return (
        <Button
            type="submit"
            tabIndex={30}
            data-name="dialog-button"
            className={classnames(className, "dialog-button")}
            style={{ ...props.style, ...buttonStyle }}
            block
            onClick={
                preventStepNavigation
                    ? (event) => {
                          event.stopPropagation();
                          event.preventDefault();
                      }
                    : onClick
            }
            href={preventStepNavigation ? undefined : href}
            {...props}
        />
    );
});
